import { render, staticRenderFns } from "./PostsAside.vue?vue&type=template&id=263e6312&scoped=true&"
import script from "./PostsAside.vue?vue&type=script&lang=js&"
export * from "./PostsAside.vue?vue&type=script&lang=js&"
import style0 from "./PostsAside.vue?vue&type=style&index=0&id=263e6312&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263e6312",
  null
  
)

export default component.exports